import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * Resources Nav Icon
 *
 * @file ResourcesNav.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

const ResourcesNav = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 22 18" {...props}>
    <path
      d="M19.5909 16H2.40909V2.5C2.40909 2.22386 2.63295 2 2.90909 2H6.58579C6.851
        2 7.10536 2.10536 7.29289 2.29289L9 4H19.5909V16ZM19.4 2.25H10.1L8.59301 0.635363C8.21475
        0.230093 7.68526 0 7.1309 0L2.6 0C1.4345 0 0.5 1.00125 0.5 2.25V15.75C0.5 16.9926 1.4402
        18 2.6 18H19.4C20.5598 18 21.5 16.9926 21.5 15.75V4.5C21.5 3.25125 20.555 2.25 19.4 2.25Z"
      fill="currentcolor"
    />
  </SvgIcon>
);

export default ResourcesNav;
